import { useState } from "react";
import { Dropdown } from "react-bootstrap";
import Icon from "../../../Layouts/Icons";
import CommonModal from "../../../Modals/CommonModal";
import Style from "./LiveProjectsCard.module.scss";
import { useNavigate } from "react-router-dom";

const LiveProjectsCard = ({
  projectData,
  project,
  client,
  location,
  mobile,
  events,
  email,
  date,
}) => {
  const [eventsInfoModal, setEventsInfoModal] = useState(false);
  const [availableEvent, setAvailableEvent] = useState(false);
  const navigate = useNavigate();
  const activeEvents = events?.filter((item) => item?.active === true);
  const otherEvents = events?.filter((item) => item?.active !== true);

  return (
    <>
      <tr className={Style.LiveProjectsCard}>
        <td data-label="Project Name">
          <span>{project}</span>
        </td>
        <td data-label="Client Name">
          <span>{client}</span>
        </td>
        <td data-label="Location">
          <span>{location}</span>
        </td>
        <td data-label="Mobile number">
          <a href={`tel: ${mobile}`}>{mobile}</a>
        </td>
        <td data-label="Events">
          <button
            className={`${Style.LiveProjectsCard__filter_button} custom-dropdown`}
            onClick={() => setAvailableEvent(!availableEvent)}
          >
            {events?.length} Events
          </button>
        </td>
        <td>
          <button className="text-btn" onClick={() => setEventsInfoModal(true)}>
            <Icon color={"currentColor"} size={16} icon={"info-icon"} />
          </button>
        </td>
      </tr>

      <CommonModal
        backdrop="static"
        keyboard={false}
        showModal={eventsInfoModal}
        setShowModal={() => {
          setEventsInfoModal(false);
        }}
        centered={true}
        className={"create-project-modal"}
        title={<h4>Project info</h4>}
        content={
          <>
            <div className={`row ${Style.LiveProjectsCard__modal__row}`}>
              <div className="col-sm-6">
                <h6 className={Style.LiveProjectsCard__modal_label}>
                  Project name
                </h6>
                <p className={Style.LiveProjectsCard__modal_val}>
                  {projectData.name}
                </p>
              </div>
              <div className="col-sm-6">
                <h6 className={Style.LiveProjectsCard__modal_label}>
                  Client name
                </h6>
                <p className={Style.LiveProjectsCard__modal_val}>
                  {projectData?.get_clients?.[0]?.["name"]}
                </p>
              </div>
              {/* {email && (<>
              <div className="col-sm-6">
                <h6 className={Style.LiveProjectsCard__modal_label}>Email address</h6>
                <p className={Style.LiveProjectsCard__modal_val}><a href={`mailto: ${email}`}>{projectData?.get_clients?.[0]?.["email"]}</a></p>
              </div>
              </>)} */}
              {projectData?.get_clients?.[0]?.["mobile"] && (
                <>
                  <div className="col-sm-6">
                    <h6 className={Style.LiveProjectsCard__modal_label}>
                      Mobile number
                    </h6>
                    <p className={Style.LiveProjectsCard__modal_val}>
                      <a
                        href={`tel: ${projectData?.get_clients?.[0]?.["mobile"]}`}
                      >
                        {projectData?.get_clients?.[0]?.["mobile"]}
                      </a>
                    </p>
                  </div>
                </>
              )}
              {projectData?.location_name && (
                <>
                  <div className="col-sm-6">
                    <h6 className={Style.LiveProjectsCard__modal_label}>
                      Location
                    </h6>
                    <p className={Style.LiveProjectsCard__modal_val}>
                      {projectData?.location_name}
                    </p>
                  </div>
                </>
              )}
              {projectData?.created_at_formatted_date && (
                <>
                  <div className="col-sm-6">
                    <h6 className={Style.LiveProjectsCard__modal_label}>
                      Date
                    </h6>
                    <p className={Style.LiveProjectsCard__modal_val}>
                      {projectData?.created_at_formatted_date}
                    </p>
                  </div>
                </>
              )}
            </div>
          </>
        }
        footer={<></>}
      />

      {/* available events modal */}
      <CommonModal
        backdrop="static"
        keyboard={false}
        showModal={availableEvent}
        setShowModal={() => {
          setAvailableEvent(!availableEvent);
        }}
        centered={true}
        className={"type-sm info-modal"}
        title={<h4> {events?.length} Events</h4>}
        content={
          <>
            <div className={` ${Style.LiveProjectsCard__modal__row}`}>
              {activeEvents?.length > 0 && (
                <div className={Style.eventInfoText}>
                  <h6
                    className={`${Style.LiveProjectsCard__modal_label} text-left`}
                  >
                    Active Event
                  </h6>
                  {activeEvents?.map((item, i) => (
                    <p
                    key={i}
                      className={`${Style.LiveProjectsCard__list_active} text-left`}
                      onClick={() => {
                        navigate(
                          `/dashboard/project/${projectData.id}/folders/${item.id}`
                        );
                      }}
                    >
                      {item.name}
                    </p>
                  ))}
                </div>
              )}

              <div className={Style.eventInfoText}>
                <h6
                  className={`${Style.LiveProjectsCard__modal_label} text-left`}
                >
                  {activeEvents?.length == 0 ? "All events" : "Other Events"}
                </h6>
                {otherEvents?.map((item,i) => (
                  <p
                  key={i}
                    className={Style.LiveProjectsCard__list}
                    onClick={() => {
                      navigate(
                        `/dashboard/project/${projectData.id}/folders/${item.id}`
                      );
                    }}
                  >
                    {item.name}
                  </p>
                ))}
              </div>
            </div>
          </>
        }
        footer={<></>}
      />
    </>
  );
};

export default LiveProjectsCard;
